import SKDCalculator from "./skdcalculator";

function App() {
  return <SKDCalculator />;
}

export default App;
